import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { Locale } from 'src/interfaces/locale.model';
import { Modificator } from 'src/interfaces/modificators.model';

@Component({
    selector: 'app-menu-modificator-card',
    templateUrl: './menu-modificator-card.component.html',
    styleUrls: ['./menu-modificator-card.component.css'],
    standalone: false
})
export class MenuModificatorCardComponent implements OnInit{
  constructor(
    private imageCache: ImageCacheService,
  ) { }

  @Input() modificator!: Modificator;
  @Input() width: number = 105;
  @Input() height: number = 140;
  @Input() locale: Locale | null = null;

  @Output() increment = new EventEmitter<Modificator>();
  @Output() decrement = new EventEmitter<Modificator>();
  @Output() toggle = new EventEmitter<Modificator>();

  // Изображение заглушка
  imageSrc: string = 'assets/no_photo_mod_ru.png';

  ngOnInit(): void {
    // Image
    if (this.modificator.image?.trim()) {
      this.imageCache.getImage(this.modificator.image).then(src => {
        this.imageSrc = src;
      });
    }
  }

  handleClick(event: MouseEvent) {
    event.stopPropagation();
    this.toggle.emit(this.modificator);
  }

  onIncrement(event: MouseEvent) {
    event.stopPropagation();
    this.increment.emit(this.modificator);
  }

  onDecrement(event: MouseEvent) {
    event.stopPropagation();
    this.decrement.emit(this.modificator);
  }

  showPrice(mod: Modificator): boolean {
    return mod.maximum == 1 || mod.count == 0;
  }

  showCounter(mod: Modificator): boolean {
    return mod.maximum != 1 && mod.count > 0;
  }
}